export const FOOTER_EXTERNAL_LINKS: { href: string; text: string }[] = [
  { href: '//bewerbung.com/', text: 'Bewerbung.com' },
  { href: '//praktikum-guide.com/', text: 'Praktikum-guide.com' },
  { href: '//anschreiben.com/', text: 'Anschreiben' },
  { href: '//lebenslauf.com/', text: 'Lebenslauf-Editor' },
];

export const getFooterExternalLinks = (
  topicKey: string
): { href: string; text: string }[] => {
  return [
    {
      href: `//bewerbung.com?sc_o=career_hub_application_other_topics_click&sc_o_PropActionOrigin=career_hub_application_${topicKey}`,
      text: 'Bewerbung.com',
    },
    {
      href: `//praktikum-guide.com?sc_o=career_hub_application_other_topics_click&sc_o_PropActionOrigin=career_hub_application_${topicKey}`,
      text: 'Praktikum-guide.com',
    },
    {
      href: `//anschreiben.com?sc_o=career_hub_application_other_topics_click&sc_o_PropActionOrigin=career_hub_application_${topicKey}`,
      text: 'Anschreiben',
    },
    {
      href: `//lebenslauf.com?sc_o=career_hub_application_other_topics_click&sc_o_PropActionOrigin=career_hub_application_${topicKey}`,
      text: 'Lebenslauf-Editor',
    },
  ];
};
